import { Section } from "../Global/Section/Section";
import styles from "./Media.module.scss";
import { MediaOptionsType } from "@/types/ModuleOptionsType";
import Media from "./Media";
import { Headline } from "../Global/Headline/Headline";
import { motion } from "motion/react";
import { scale_variant } from "../../utils/animation/transitions";
import { Modul_Media } from "../../wp/types/acf-module-types";
import { useSublinesVisibility } from "../../hooks/useSublinesOverlinesVisibility";
import { checkModuleIsHidden } from "@/utils/checkModuleIsHidden";

export type MediaModuleType = Modul_Media;

interface MediaProps {
  data: MediaModuleType;
  noSection?: boolean;
  mediaOptions: MediaOptionsType;
}

const MediaModul = ({ data, noSection, mediaOptions }: MediaProps) => {
  const {
    media_format: mediaFormat,
    show_audio_icon: showAudioIcon,
    show_overline_subline,
    box: { show_border_radius, show_box_shadow, show_card_box },
    show_original_format,
  } = mediaOptions || {};
  const {
    section_padding_class,
    background_color_class,
    headline_text_align_class,
    id,
    module_width,
    keep_media_format,
  } = data.layout;
  const { headline_html_tag, headline, overline, subline } = data.media;
  const { showOverline, showSubline } = useSublinesVisibility(
    show_overline_subline ?? "none",
  );

  {
    /* jscpd:ignore-start */
  }
  //! check if module is hidden
  const isHidden = checkModuleIsHidden(data.settings);
  if (isHidden) {
    return null;
  }
  {
    /* jscpd:ignore-end */
  }

  if (noSection) {
    return (
      <Media
        mediaData={data.media.media}
        mediaFormat={mediaFormat}
        showAudioIcon={showAudioIcon}
      />
    );
  } else {
    return (
      <Section
        className={`${styles.media} ${background_color_class} ${section_padding_class} ${show_card_box && show_border_radius ? styles["has-border-radius"] : ""} ${show_card_box && show_box_shadow ? styles["has-box-shadow"] : ""}`}
        frameless={module_width === "frameless"}
        id={id}
      >
        <div
          className={`column ${module_width === "narrow-frame" ? "is-9-desktop is-8-widescreen is-offset-1-widescreen" : "is-12"}`}
        >
          <Headline
            headline_html_tag={headline_html_tag}
            headline={headline}
            extraClass={headline_text_align_class}
            subline={showSubline ? subline : ""}
            overline={showOverline ? overline : ""}
            wrapInSection={module_width === "frameless"}
            disableAnimation
          />

          <motion.div
            initial="initial"
            whileInView="animate"
            variants={scale_variant}
            viewport={{ amount: 0.1, once: true }}
          >
            <Media
              mediaData={data.media.media}
              mediaFormat={
                show_original_format && keep_media_format
                  ? undefined
                  : mediaFormat
              } // keep_media_format is used to keep the original media format
              showAudioIcon={showAudioIcon}
            />
          </motion.div>
        </div>
      </Section>
    );
  }
};

export default MediaModul;
